import { render, staticRenderFns } from "./LocalPaymentsAddPayeeFailure.vue?vue&type=template&id=3b54f8da"
import script from "./LocalPaymentsAddPayeeFailure.vue?vue&type=script&lang=js"
export * from "./LocalPaymentsAddPayeeFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports